export const ACTION_REQUEST = 'FETCH_VIDEOSERIES_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEOSERIES_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEOSERIES_ERROR';
